import {ClassificationField} from "./classification-field";
import {Determinant} from "./determinant";
import {SelectOperatorType} from "./select-operator";
import {SelectSubjectType} from "./select-subject";
import {ClassificationGroup} from "./classification-group";

export class ClassificationDeterminant extends Determinant {

  public catalog: string;
  public classificationField: ClassificationField;
  public classificationFieldIds: ClassificationField[];
  public operator: SelectOperatorType;
  public subject: SelectSubjectType;
  public classificationGroup: ClassificationGroup;
  public classificationFields: ClassificationField[];

}
